export default __webpack_public_path__ + "static/media/earlySubscriberAndroid_5.96ba332b.svg";